/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-underscore-dangle */
/* eslint-disable react/no-array-index-key */

import React, { Fragment, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { connect, useDispatch, useSelector } from "react-redux";
import clsx from "clsx";
import moment from 'moment';
import Grid from "@material-ui/core/Grid";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import Select from "react-select";
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Button } from "../../atomicComponents";
import { CustomDatePicker } from "../FormComponents";
import tableIcons from "./MaterialTableIcons";
import styles from "./RequestorDashboardForm.module.css";
import { MESSAGE_TYPE } from "../../constants";
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import Truckloading from "../CvLoader/Cvloader";
import { setLogin } from '../../redux/features/auth/actions';


function RequestorDashboardForm() {
  const history = useHistory();
  const dispatchNew= useDispatch();
  const location = useLocation();
  const baseURL = useSelector((state) => state.counter.baseUrl);
  const auth = useSelector((state) => state.auth);
  let {
    userName,
    personNumber,
    companyCode,
    bookingStatus,
    costCenter,
    userRole,
    sessionId,
    req_dash_cnt,
    apiSendData
  } = auth;

  const data = location.state?.data;
  
  const stateData = apiSendData == undefined ? data : apiSendData;


  const URole = userRole.includes("U");
  const LIRole = userRole.includes("LI");
  const SARole = userRole.includes("SA");
  const BRole = userRole.includes("B");

  const { useState } = React;
  const { showPopup } = usePopupManager();
  
    // Calculate the date one month ago
    const currentDate = new Date();
    const oneMonthAgo = new Date(currentDate);
    oneMonthAgo.setMonth(oneMonthAgo.getMonth() - 1);

  const [mobile, setMobile] = useState(window.innerWidth <= 500);
  const [loading, setLoading] = useState(false);
  const [globalFilter, setGlobalFilter] = useState('');
  const [filters, setFilters] = useState(null);
  const [displayView, setDisplayView] = useState(true);
  const [tableDisplay, setTableDisplay] = useState(false);
  const [reqType, setReqType] = useState("");
  const [reqStatus, setReqStatus] = useState("");
  const [selectedDate, setSelectedDate] = useState(moment(oneMonthAgo).format('YYYY-MM-DD'));
  const [selectedToDate, setSelectedToDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [daysDifference, setDaysDifference] = useState(null);
  const [monthDiff, setMonthDiff] = useState(0);
  const [apiPayloadData, setAPIPaylodData] = useState(stateData);

  const [convertedData, setConvertedData] = useState([]);

  useEffect(() => {
    window.addEventListener("resize", handleWindowSizeChange);
    return () => {
      window.removeEventListener("resize", handleWindowSizeChange);
    };
  }, []);

  const options2 = [
    { label: "In Progress", value: null },
    { label: "Approved", value: "C" },
    { label: "Rejected", value: "R" },
    // Add more options as needed
  ];

  const handleFromDateChange = (date) => {
    setSelectedDate(moment(date).format('YYYY-MM-DD'));
    setConvertedData([]);
    if(data != undefined && apiPayloadData.start_date == ''){
      setAPIPaylodData({
        ...apiPayloadData,
        start_date: moment(date).format('YYYY-MM-DD'),
        end_date: selectedToDate
      })
    }else {
      setAPIPaylodData({
        ...apiPayloadData,
        start_date: moment(date).format('YYYY-MM-DD'),
        end_date: selectedToDate
      })
    }
  };

  const handleToDateChange = (date) => {
    setSelectedToDate(moment(date).format('YYYY-MM-DD'));
    setConvertedData([]);
    if(data != undefined && apiPayloadData.start_date == ''){
      setAPIPaylodData({
        ...apiPayloadData,
        start_date: selectedDate,
        end_date: moment(date).format('YYYY-MM-DD')
      })
    }else{
      setAPIPaylodData({
        ...apiPayloadData,
        start_date: selectedDate,
        end_date: moment(date).format('YYYY-MM-DD')
      })
    }
  };

  
  const [columns] = useState([
    {
      title: "Sr No",
      field: "SRNo",
      editable: "false",
      cellStyle: {
        fontSize: mobile ? "10px" : "13px",
      },
    },
    {
      title: "Request No",
      field: "RequestNo",
      editable: "false",
      cellStyle: {
        fontSize: mobile ? "10px" : "13px",
      },
      render: (row) => (
        <div className="">
          <div>
              <span
                onClick={(event) => handleReqViewClick(event, row.SuperAdmin[0])}
                style={{
                  color: "#608FC9",
                  cursor: "pointer",
                  borderBottom: "1px solid #608FC9",
                }}
              >
                {row.RequestNo}
              </span>
          </div>
        </div>
      ),
    },
    {
      title: "Request Type",
      field: "RequestType",
      editable: "false",
      cellStyle: {
        fontSize: mobile ? "10px" : "13px",
      },
    },
    {
      title: "Employee Name",
      field: "OldEMPName",
      editable: "false",
      cellStyle: {
        fontSize: mobile ? "10px" : "13px",
      },
    },
    {
      title: "BC Head",
      field: "bchead",
      editable: "false",
      cellStyle: {
        width: "20%",
        fontSize: mobile ? "10px" : "13px",
      },

      render: (row) => (
        <div className={clsx(styles.Rdetails, styles[row.bchead[0].status])}>
          <div>
            {row.bchead[0].status == "INPROGRESS" && userRole.includes("B") && personNumber==row.bchead[0].employeepersno ? (
              <span
                // href=""
                onClick={(event) => handleBCHeadClick(event, row.bchead[0])}
                style={{
                  color: "#608FC9",
                  cursor: "pointer",
                  borderBottom: "1px solid #608FC9",
                }}
              >
                {row.bchead[0].name}
              </span>
            ) : (
              <span style={{ color: "#608FC9" }}>{row.bchead[0].name}</span>
            )}
          </div>
          <div>
            <span style={{ color: "#608FC9" }}>
              {row.bchead[0].approvalDate}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: "Super Admin",
      field: "SuperAdmin",
      editable: "false",
      cellStyle: {
        width: "20%",
        fontSize: mobile ? "10px" : "13px",
      },
      render: (row) => (
        <div
          className={clsx(styles.Rdetails, styles[row.SuperAdmin[0].status])}
        >
          <div>
            {row.SuperAdmin[0].status === "ACCEPTED" ||
            row.SuperAdmin[0].status === "REJECTED" ||
            row.SuperAdmin[0].status === "YETTOSTART" ? (
              <span style={{ color: "#608FC9" }}>
                {row.SuperAdmin[0]?.name || "SBP Team"}
              </span>
            ) : null}
            {row.SuperAdmin[0].status === "INPROGRESS" &&
            userRole.includes("SA") ? (
              <span
                // href="#"
                onClick={(event) => handleAdminClick(event, row.SuperAdmin[0])}
                style={{
                  color: "#608FC9",
                  borderBottom: "1px solid #608FC9",
                  cursor: "pointer",
                }}
              >
                {row.SuperAdmin[0]?.name || "SBP Team"}
              </span>
            ) : row.SuperAdmin[0].status === "INPROGRESS" &&
              !userRole.includes("SA") ? (
              <span style={{ color: "#608FC9" }}>
                {row.SuperAdmin[0]?.name || "SBP Team"}
              </span>
            ) : null}
          </div>
          <div>
            <span style={{ color: "#608FC9" }}>
              {row.SuperAdmin[0].approvalDate}
            </span>
          </div>
        </div>
      ),
    },
    {
      title: "Status",
      field: "SuperStatus",
      editable: "false",
      cellStyle: {
        fontSize: mobile ? "10px" : "13px",
      },
    },
  ]);

  const baseDefaultColumns = [
    {
      width: 50,
      textAlign: 'center',
      title: 'SR No',
      field: 'SRNo',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      textAlign: "center",
      title: 'Request No',
      field: 'RequestNo',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 150,
      title: 'Request Type',
      field: 'RequestType',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: 'Employee Name',
      field: 'OldEMPName',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: "BC Head",
      field: "bchead",
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 0,
      title: '',
      field: 'RequestNoHide',
      enableSearch: true,
      enableFilter: true,
    },
    {
      width: 200,
      title: "Super Admin",
      field: "SuperAdmin",
      enableSearch: true,
      enableFilter: true,
    },
  {
    width: 100,
    title: 'Status',
    field: 'SuperStatus',
    enableSearch: true,
    enableFilter: true,
  }
  ];


  const handleWindowSizeChange = () => {
    setMobile(window.innerWidth <= 500);
  };

  const RequestNoLink = (requestNo, requestType, payloadData) => {
    const sendAPIData = payloadData;
    return (
      <div className="">
      <div>
          <span
            onClick={(event) => {
              event.preventDefault();
              history.push(`/request-view/${requestType}/${requestNo}`);
              dispatchNew(setLogin({ ...auth, apiSendData: sendAPIData}));
            }}
            style={{
              color: "#608FC9",
              cursor: "pointer",
              borderBottom: "1px solid #608FC9",
            }}
          >
            {requestNo}
          </span>
      </div>
    </div>
    )
  };

  const BCHeadLink = (requestNo, requestType, bcHeadStatus, bcHeadEmpNo, bcHeadName, bcHeadAppDate, payloadData) => {
    const sendAPIDataBcHead = payloadData;
    return(
      <div className={clsx(styles.Rdetails, styles[bcHeadStatus])}>
          <div>
            {bcHeadStatus == "INPROGRESS" && userRole.includes("B") && personNumber == bcHeadEmpNo ? (
              <span
                onClick={(event) => {
                  event.preventDefault();
                  history.push(`/access-control/${requestType}/${requestNo}`);
                  dispatchNew(setLogin({ ...auth, apiSendData: sendAPIDataBcHead}));
                }}
                style={{
                  color: "#608FC9",
                  cursor: "pointer",
                  borderBottom: "1px solid #608FC9",
                }}
              >
                {bcHeadName}
              </span>
            ) : (
              <span style={{ color: "#608FC9" }}>{bcHeadName}</span>
            )}
          </div>
          <div>
            <span style={{ color: "#608FC9" }}>
              {bcHeadAppDate}
            </span>
          </div>
      </div>

    )

  }

  const SuperAdminLink = (requestNo, requestType, supAStatus, supAName, supAAppDate, modifyBy, payloadData) => {
    const sendAPIDataSupAdmin = payloadData;
    return(
      <div className={clsx(styles.Rdetails, styles[supAStatus])}>
          <div>
            {supAStatus === "ACCEPTED" ||
            supAStatus === "REJECTED" ||
            supAStatus === "YETTOSTART" ? (
              <span style={{ color: "#608FC9" }}>
                  {(supAName == "SYSTEM" ? "SYSTEM" : "SBP Team") || supAName}
              </span>
            ) : null}
            {supAStatus === "INPROGRESS" &&
            userRole.includes("SA") ? (
              <span
                onClick={(event) => {
                  event.preventDefault();
                  history.push(`/access-control/${requestType}/${requestNo}`);
                  dispatchNew(setLogin({ ...auth, apiSendData: sendAPIDataSupAdmin}));
                }}
                style={{
                  color: "#608FC9",
                  borderBottom: "1px solid #608FC9",
                  cursor: "pointer",
                }}
              >
                {(supAName == "SYSTEM" ? "SYSTEM" : "SBP Team") || supAName}
              </span>
            ) : supAStatus === "INPROGRESS" &&
              !userRole.includes("SA") ? (
              <span style={{ color: "#608FC9" }}>
                {(supAName == "SYSTEM" ? "SYSTEM" : "SBP Team") || supAName}
              </span>
            ) : null}
          </div>
          <div>
            <span style={{ color: "#608FC9" }}>
              {supAAppDate}
            </span>
          </div>
        </div>

    )

  }

   
    const processData = (tbdata, payloadData) => {
 
      // console.log("API Data: ", tbdata);
      const processedData = tbdata.map((entry, index) => ({
        SRNo: (index + 1).toString(),
        RequestNo: RequestNoLink(entry.request_no, entry.request_code, payloadData),
        RequestNoHide: entry.request_no,
        RequestType: entry.request_type,
        // RequesterName: entry.requester_name,
        OldEMPName: entry.employee_name,
        modifyBy: entry.modified_by,
        SuperStatus:
          entry.status === "INPROGRESS" ? "In Progress" : entry.status.charAt(0).toUpperCase() + entry.status.slice(1).toLowerCase(),
          bchead: BCHeadLink(entry.request_no,entry.request_code,entry.bc_approval_status,entry.bc_head_persno,entry.bc_head_name,entry.bc_approved_date,payloadData),
          SuperAdmin: SuperAdminLink(entry.request_no,entry.request_code,entry.admin_approval_status,entry.super_admin_name,entry.admin_approved_date,entry.modified_by,payloadData),
      }));
  
      return processedData;
    };
  
  const onClickSubmitBtn = () => {
    
    // const apiFormatedData = {
    //   user_id: personNumber,
    //   req_type: reqType,
    //   request_status: reqStatus.value,
    //   start_date: selectedDate,
    //   end_date: selectedToDate,
    // };

    let apiFormatedData = {};
    if (reqType != "" && reqStatus != "") {
      apiFormatedData = {
        user_id: personNumber,
        req_type: reqType,
        request_status: reqStatus?.value,
        start_date: selectedDate,
        end_date: selectedToDate,
      };
    } 
        else if (reqType == "" && reqStatus == "") {
          if (SARole || BRole) {
            apiFormatedData = {
              user_id: personNumber,
              req_type: "approval",
              request_status: null,
              start_date: selectedDate,
              end_date: selectedToDate,
            };
            setReqType("approval");
            setReqStatus({ label: "In Progress", value: null });
            setDisplayView(true);
          } else {
            apiFormatedData = {
              user_id: personNumber,
              req_type: "created",
              request_status: null,
              start_date: selectedDate,
              end_date: selectedToDate,
            };
            setReqType("created");
            setReqStatus({ label: "In Progress", value: null });
            setDisplayView(false);
          }
        } 
    else {
      apiFormatedData = {
          user_id: personNumber,
          req_type: "approval",
          request_status: null,
          start_date: selectedDate,
          end_date: selectedToDate,
      };
        setReqType("approval");
        setReqStatus({ label: "In Progress", value: null });
        setDisplayView(false);
    }

    setLoading(true);

    // console.log("state api data: ", apiPayloadData);

    let apiFormatedData_updated = {};

    if(data != undefined && apiPayloadData.start_date == '' ){
      apiFormatedData_updated = ({...apiPayloadData, start_date: selectedDate, end_date: selectedToDate});
      apiFormatedData = apiFormatedData_updated;
      // console.log("inner state api data: ", apiFormatedData);
      
      setReqType(apiPayloadData.req_type);
      setReqStatus(apiPayloadData.request_status == null ? { label: "In Progress", value: null } : reqStatus);
    }
    else if(apiSendData != undefined){
      if(apiSendData.start_date == ""){
        apiFormatedData = ({...apiPayloadData, start_date: selectedDate, end_date: selectedToDate});
      }else{
        apiFormatedData = apiPayloadData;
      }
      // console.log("Req api data: ", apiFormatedData);

      setReqType(apiFormatedData.req_type)
      setReqStatus(apiFormatedData.request_status == null ? { label: "In Progress", value: null } :
      apiPayloadData.request_status == 'C' ? { label: "Approved", value: "C" } :
      apiPayloadData.request_status == 'R' ? { label: "Rejected", value: "R" } : reqStatus);
      setSelectedDate(apiFormatedData.start_date);
      setSelectedToDate(apiFormatedData.end_date);
    }
    const apiFormatedDataJson = JSON.stringify(apiFormatedData);
    const token = sessionStorage.getItem('token')
    const headerss = new Headers();
    const sessionId = sessionStorage.getItem('sessionId')
    headerss.append('X-Session-Id', sessionId)
    headerss.append("Content-Type", "application/json");
    headerss.append("authorization", `Bearer ${token}`);
    fetch(`${baseURL}master/accesscontroldashboard`, {
      method: "POST",
      headers: headerss,
      credentials:'include',
      body: apiFormatedDataJson,
    })
      .then((response) => {
        dispatchNew(setLogin({ ...auth, recentStatus: response.status }));
        if (response.status === 403) {
          dispatchNew(setLogin({ ...auth, recentStatus: response.status }));
        }
        return response.json();
      })
      .then((responseJSON) => {
        // console.log("daysDifference----------> ", daysDiffaerence);

        if (responseJSON.msg === "Success") {
          // setConvertedData([]);
          setLoading(false);
          if(monthDiff <=2){
          if (responseJSON.data.length >= 1) {
            setConvertedData([]);
            const processedData = processData(responseJSON.data, apiFormatedData);
            setConvertedData(processedData);
            setTableDisplay(true);

          } else {
            setTableDisplay(false);
            setConvertedData([]);
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "Data Not Found",
            });

            setTableDisplay(false);
          }
          }
        } else if (responseJSON.msg === "Info") {
          setLoading(false);
          setTableDisplay(false);
          setConvertedData([]);
          if (responseJSON.data != "User Logged In On another Screen") {

            if (daysDifference === null || daysDifference < 0) {
              setLoading(false);
              setTableDisplay(false);
              setConvertedData([]);
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                info: "To date should not be less than From date",
              });
            }else{
              showPopup({
                type: MESSAGE_TYPE.INFORMATION,
                contextText: MESSAGE_TYPE.INFORMATION,
                // info: "Oops! The selected dates should be within a range of 60 days or less",
                info: "Report can be fetched maximum for two months"
                // info: response.data
              });
            }
          }
        } else if (responseJSON.msg === "Fail") {
          setLoading(false);
          showPopup({
            type: MESSAGE_TYPE.FAILURE,
            contextText: MESSAGE_TYPE.FAILURE,
            info: "Oops! Something went wrong. Please try again later",
          });
        }
      })
      .catch((error) => {
        // console.log("error---------->", error)
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Something Went wrong.",
        });
      });
  };

  useEffect(() => {
    onClickSubmitBtn();
  }, []);

  const initFilters = () => {
    const initialFilters = {global: { value: null, matchMode: FilterMatchMode.CONTAINS }};
    baseDefaultColumns.forEach((column) => { 
      initialFilters[column.field] ={ value: null, matchMode: FilterMatchMode.CONTAINS };
    });
    setFilters(initialFilters);
  };
  useEffect(() => {
    initFilters();
  }, []);

  const clearFilter = () => {
    initFilters();
  };

  const onGlobalFilterChange = (e) => {
    const {value} = e.target;
    const _filters = { ...filters };

    _filters.global.value = value;

    setFilters(_filters);
    setGlobalFilter(value);
};

  const handleChange1 = (event) => {
    setReqType(event.target.value);
    setConvertedData([]);
    if(data != undefined && apiPayloadData.start_date == ''){
      setAPIPaylodData({
        user_id: personNumber,
        req_type: event.target.value,
        request_status: reqStatus.value
      })
    }else{
      setAPIPaylodData({
        user_id: personNumber,
        req_type: event.target.value,
        request_status: reqStatus.value,
        start_date: selectedDate,
        end_date: selectedToDate
      })
    }
  };

  const handleChange2 = (selectedOptions2) => {
    setReqStatus(selectedOptions2);
    setConvertedData([]);
    if(data != undefined && apiPayloadData.start_date == ''){
      setAPIPaylodData({
        user_id: personNumber,
        req_type: reqType,
      request_status: selectedOptions2.value,
      })
    }else{
      setAPIPaylodData({
        user_id: personNumber,
        req_type: reqType,
        request_status: selectedOptions2.value,
        start_date: selectedDate,
        end_date: selectedToDate
      })
    }
  };
  
  useEffect(() => {
    if (selectedDate && selectedToDate) {
      const startDate = new Date(selectedDate);
      const endDate = new Date(selectedToDate);
      
      const startYear = startDate.getFullYear();
      const endYear = endDate.getFullYear();
      const startMonth = startDate.getMonth();
      const endMonth = endDate.getMonth();
      
      const yearDiff = endYear - startYear;
      // Convert difference to Months
      const monthDifference = endMonth - startMonth + (yearDiff * 12);
      setMonthDiff(monthDifference);
  
      const startMs = startDate.getTime();
      const endMs = endDate.getTime();
      // Calculate difference in milliseconds
      const differenceInMs = endMs - startMs;
      // Convert difference to days
      const differenceInDays = differenceInMs / (1000 * 60 * 60 * 24);
      setDaysDifference(differenceInDays);
    }
  },[selectedDate,selectedToDate]);
  
    const DateGroup = () => (
      <div>
        <Grid
          container
          spacing={1}
          style={{ display: "flex", justifyContent: "left" }}
          columns={12}
        >
          <Grid item md={6} lg={6}>
          <div style={{marginLeft: '-10px', width: '110%', display: "flex" }}>
              <div className={clsx(styles.lableDiv)}>
                <label>From Date: </label>
              </div>
              <div className={styles.formDiv}>
                <CustomDatePicker
                  clearable
                  autoOk
                  inputVariant="outlined"
                  inputProps={{
                    className: clsx(styles.select, styles.dateInput),
                  }}
                  emptyLabel="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                  value={selectedDate}
                  onChange={handleFromDateChange}
                  data-testid="date-picker-div-1"
                  style={{ width: "50%" }}
                />
              </div>
            </div>
          </Grid>
          <Grid item md={5} lg={5}>
            <div style={{ marginLeft: "-35%", display: "flex" }}>
              <div className={clsx(styles.lableDiv)}>
                <label>To Date: </label>
              </div>
              <div className={styles.formDiv}>
                <CustomDatePicker
                  clearable
                  autoOk
                  inputVariant="outlined"
                  value={selectedToDate}
                  onChange={handleToDateChange}
                  inputProps={{
                    className: clsx(styles.select, styles.dateInput),
                  }}
                  emptyLabel="DD-MM-YYYY"
                  format="DD-MM-YYYY"
                  style={{ width: "50%", marginLeft: "-5%"}}
                />
              </div>
            </div>
          </Grid>
          <Grid item md={1} lg={1}>
            <div style={{ marginLeft: "-110px", width: "100%", display: "flex" }}>
              <div className={styles.formDiv}>
                <Button
                  className={clsx(
                    styles.actionButton,
                    styles.primaryActionButton
                  )}
                  variant="primary"
                  // disabled={disable}
                  onClick={() => onClickSubmitBtn()}
                  // onClick={() => onClickSubmitNew()}
                  data-testid="confirm-action"
                >
                  SUBMIT
                </Button>
               
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    );


  const gridItem = displayView ? 6 : 12;

  const MyRequestView = () => (
    <Grid container spacing={1} columns={12}>
      <Grid item md={gridItem} lg={gridItem} sm={12} xs={12}>
        <RadioGroup
          row
          aria-labelledby="demo-row-radio-buttons-group-label"
          name="row-radio-buttons-group"
          label="role1"
          value={reqType}
          onChange={handleChange1}
        >
          <FormControlLabel
            value="created"
            name="role1"
            control={<Radio size="small" />}
            label="My Request (Raised by me)"
            style={{ color: "black" }}
            className={styles.radiobtn}
          />
        </RadioGroup>
      </Grid>
      {displayView ? (
        <Grid item md={6} lg={6} sm={12} xs={12}>
          <RadioGroup
            row
            aria-labelledby="demo-row-radio-buttons-group-label"
            name="row-radio-buttons-group"
            value={reqType}
            onChange={handleChange1}
            style={{ marginLeft: "-20px" }}
          >
            <FormControlLabel
              value="approval"
              name="role2"
              control={<Radio size="small" />}
              label="My Approval (Pending on me)"
              style={{ color: "black" }}
              className={styles.radiobtn}
            />
          </RadioGroup>
        </Grid>
      ) : (
        ""
      )}
    </Grid>
  );

  const selectGroup = () => (
    <div>
      <Grid
        container
        spacing={1}
        style={{ display: "flex", justifyContent: "left" }}
        columns={12}
      >
        <Grid item md={7} lg={7}>
          {MyRequestView()}
        </Grid>
        <Grid item md={5} lg={5}>
          <div className={styles.rowDiv} style={{ marginLeft: "-18%" }}>
            <div className={clsx(styles.lableDiv)}>
              <label>Status: </label>
            </div>
            <div className={styles.formDiv} style={{ marginRight: "-10%" }}>
              <Select
                className={clsx(styles.select, styles.sel2)}
                options={options2}
                value={reqStatus}
                onChange={handleChange2}
                name="Status"
                // menuIsOpen={true}
                styles={{
                  menu: (styles1) => ({ ...styles1, zIndex: 24 }),
                  menuList: (provided) => ({
                    ...provided,
                    // fontSize:isMobileDevice ? "10px" : "14px",
                    zIndex: 24,
                    "&::-webkit-scrollbar": {
                      width: "4px !important",
                      height: "6px",
                      display: "block !important",
                      background: "none",
                    },
                    "&::-webkit-scrollbar-track": {
                      background: "none",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      background: "#f17c7c",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      background: "#da6363",
                    },
                  }),
                }}
              />
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const RadioGroupRole = () => (
    <Grid
      container
      spacing={0}
      style={{ marginTop: "10px" }}
      // className={styles.myGrid}
      columns={12}
    >
      <Grid item md={6} lg={6} sm={12} xs={12}>
        {selectGroup()}
      </Grid>
      <Grid item md={6} lg={6} sm={12} xs={12}>
        {DateGroup()}
      </Grid>
    </Grid>
  );

  const CustomTitle = () => (
    <div style={{ marginTop: "10px" }}>
      <Grid container columns={12} className={styles.myGrid}>
        <Grid item md={12} lg={12} sm={12}>
          <div className={styles.rowDiv_circle}>
            <div className={styles.formDiv}>
              <div
                className={styles.circle}
                style={{ backgroundColor: "rgba(130, 193, 167)" }}
              >
                {" "}
              </div>
              <div className={styles.lableMaster}>
                <span className={styles.title2}>Request Approved</span>
              </div>
            </div>
            <div className={styles.formDiv}>
              <div
                className={styles.circle}
                style={{ backgroundColor: "#f42323" }}
              >
                {" "}
              </div>
              <div className={styles.lableMaster}>
                <span className={styles.title2}>Request Rejected</span>
              </div>
            </div>
            <div className={styles.formDiv}>
              <div
                className={styles.circle}
                style={{ backgroundColor: "#FFA222" }}
              >
                {" "}
              </div>
              <div className={styles.lableMaster}>
                <span className={styles.title2}>Request In Progress</span>
              </div>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const renderReport = () => (
    <div className={styles.formGroup}>
      <div
        style={{
          width: "100%",
          height: "50%",
          marginTop: "10px",
          marginBottom: "10px",
        }}
      >
         <Grid
          container
          style={{
            marginTop: "10px",
            justifyContent: "center",
            margin: "10px",
          }}
          columns={12}
          className={styles.myGrid}
        >
          <Grid item md={12} lg={12} sm={12} xs={12}>
            <div style={{ marginTop: "6px" }}>{RadioGroupRole()}</div>
          </Grid>
          {tableDisplay && convertedData.length >= 1 ? (
            <Grid item md={12} lg={12} sm={12}>
              <Grid
                container
                style={{
                  marginTop: "10px",
                  justifyContent: "center",
                }}
                columns={12}
                className={styles.myGrid}
              >
              <Grid item md={9} lg={9} sm={12}>
                {CustomTitle()}
              </Grid>
            <Grid item md={3} lg={3} sm={12}>
                <div style={{ display: 'flex', alignItems: 'center' }}>
                <span className="p-input-icon-left">
                  <i className="pi pi-search" />
                  <InputText value={globalFilter} onChange={onGlobalFilterChange} placeholder="Keyword Search" style={{ fontSize: '12px', margin: '3px' }} />
                </span>
              </div>
              </Grid>
              </Grid>
            </Grid>
          ) : (
            ""
          )}
        </Grid>
        {loading ? (
          <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
               <Truckloading />
            </div>
       
        ) : (
         
          <>
            {convertedData.length >= 1 ? (
            
            <DataTable 
              value={convertedData}
              resizableColumns
              scrollable
              style={{minWidth: '50rem', fontSize: "10px" }}
              tableStyle={{minHeight:'270px', fontSize: '12px'}}
              globalFilter={globalFilter}
              filters={filters} 
              onFilter={(e) => setFilters(e.filters)}
              size='small'
              paginator rows={5} 
              rowsPerPageOptions={[5, 10, 25, 50]}
              >
                {baseDefaultColumns.map((column, index) => (
                    <Column
                      key={index}
                      field={column.field}
                      header={column.title}
                      style={{ width: column.width , textAlign: column.textAlign}}
                      className={column.field === 'RequestNoHide' ? styles.hiddenColumn : styles.columCss}
                    />
                ))}
            </DataTable>
            ) : ("")
          }
          </>
          )}
      </div>
      
    </div>
  );

  return (
    <>
      <div
        className={clsx(
          styles.scrollContainer,
          styles.scrollBar,
          styles.formContainer
        )}
      >
        
        <>{renderReport()}</>
      </div>
    
    </>
  );
}

export default RequestorDashboardForm;